import { render, staticRenderFns } from "./PALifeCycle.vue?vue&type=template&id=08fd1565&"
import script from "./PALifeCycle.vue?vue&type=script&lang=js&"
export * from "./PALifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./PALifeCycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PALifeCycle.vue"
export default component.exports